"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALIGN_JUSTIFY_CONTENT_LTR = exports.ALIGN_JUSTIFY_CONTENT = void 0;
const ALIGN_JUSTIFY_CONTENT = exports.ALIGN_JUSTIFY_CONTENT = {
  left: 'flex-end',
  center: 'center',
  right: 'flex-start'
};
const ALIGN_JUSTIFY_CONTENT_LTR = exports.ALIGN_JUSTIFY_CONTENT_LTR = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};